<template>
  <div class="rich-page">
    <div class="images" v-if="bannerImagesData">
      <loop-play-images
        :images-data="bannerImagesData"
        :background-appe-mode="false"
        :default-classes="defaultClasses"
      />
    </div>
    <div class="rich-content" :style="{ minHeight }" v-html="content"></div>
  </div>
</template>

<script>
import LoopPlayImages from '@/components/common/LoopPlayImages.vue'

export default {
  name: 'RichPage',
  components: { LoopPlayImages },
  data() {
    return {
      minHeight: '',
      content: '',
      bannerImagesData: null,
      defaultClasses: {
        outerRotateStage: 'loopImages',
        rotateStage: 'loopStage',
        innerShow: 'loopContainer',
        btn: 'btnOuter',
        circular: 'dots'
      }
    }
  },
  computed: {
    pageTitle() {
      return this.$route.query.pageTitle || ''
    }
  },
  mounted() {
    this.minHeight = `${document.body.clientHeight + 80}px`
    this.getData()
  },
  watch: {
    '$route.query'() { this.getData() }
  },
  methods: {
    getData() {
      this.$axios({
        url: '/realNet/pageManager/findOne',
        method: 'get',
        headers: { token: '123456789' },
        params: { title: this.pageTitle }
      }).then(res => {
        if (res.data.result) {
          this.content = res.data.result.content || ''
          const dataMap = res.data.result.dataMap || {}
          if (dataMap.bannerList) {
            this.bannerImagesData = dataMap.bannerList.map(t => ({
              backgroundImage: t.image,
              imageLinkRouterName: t.link
            }))
          }
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rich-page {
  padding-top: $header-height + 30px;
}

.rich-content {
  width: $content-width;
  margin: 0 auto;
  padding-bottom: 60px;
  font-size: 14px;
  line-height: 1.8;
  color: #333;

  ::v-deep img { max-width: 100%; }
}

.images {
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;

  ::v-deep img {
    width: 100%;
    height: 576px !important;
  }

  ::v-deep #loopImages {
    height: 576px !important;
  }
}
</style>
